import Cookies from 'js-cookie';
import { cookieNames } from '@/enum';
var DARK = 'g-theme--dark';
export function switchTheme() {
  if (document.body.classList.contains(DARK)) {
    document.body.classList.remove(DARK);
    Cookies.remove(cookieNames.theme);
  } else {
    document.body.classList.add(DARK);
    Cookies.set(cookieNames.theme, DARK);
  }
}
export function initTheme() {
  if (Cookies.get(cookieNames.theme)) {
    document.body.classList.add(DARK);
  }
}
export function clearTheme() {
  document.body.classList.remove(DARK);
}